import {
  getQueryInstances,
  getLabeledLatestValue,
  getLabelCountData,
  getMetricData,
  getServiceForTeamWithTotalCount
} from '../fragments/vm';

export const getQueryVMInstances = `query queryInstanceDetail(${getQueryInstances.variable}) {${getQueryInstances.query}}`;

export const queryLatestValue = `query queryData(${getLabeledLatestValue.variable}) {${getLabeledLatestValue.query}}`;

export const queryMeterCount = `query queryData(${getLabelCountData.variable}) {${getLabelCountData.query}}`;

export const queryAllVMInstances = `query getServiceForTeamWithTotalCount(${getServiceForTeamWithTotalCount.variable}) {${getServiceForTeamWithTotalCount.query}}`;

export const queryMeterValue = `query queryData(${getMetricData.variable}) {${getMetricData.query}}`;
